<template>
  <div class="search-result-page">
    <TopBanner />
    <div class="search-scroll-area">
      <div style="background: #fff">
        <div style="max-width: 1200px; margin: 0 auto; padding: 24px 0">
          <SearchBar :category.sync="category" :keyword.sync="keyword">
            <template #action>
              <el-button type="primary" class="search-btn" @click="handleSearch">立即查询</el-button>
            </template>
          </SearchBar>
        </div>
      </div>

      <div class="header-bar">
        <el-breadcrumb separator=">" style="font-size: 16px">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>搜索结果</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <el-select v-model="filterCategory" class="filter-select">
          <el-option label="全部分类" value="all"></el-option>
          <el-option v-for="item in myProductTypeList" :key="item.productTypeId + ''" :label="item.typeName" :value="item.productTypeId + ''"></el-option>
        </el-select> -->
      </div>

      <div class="result-list">
        <div v-for="item in resultList" :key="item.demandId" class="result-card">
          <div class="card-header">
            <div class="user-info">
              <div class="avatar">
                <img v-if="item.avatar" :src="item.avatar" alt="avatar" />
                <div v-else class="avatar-placeholder">
                  <img src="@/assets/image/avatar.png" />
                </div>
              </div>
              <span class="user-name">{{ item.appUser?.userName || "无" }}</span>
            </div>
            <div>
              <div class="contact-info">
                <img style="width: 18px; height: 18px" src="@/assets/image/iconPhone.png" />
                <span class="phone">{{ item.relationPhone }}</span>
              </div>
              <div class="company">{{ item.appUser?.enterpriseName || "无" }}</div>
            </div>
          </div>

          <div class="card-body">
            <div class="info-row clamp1" style="color: #333333; font-size: 20px">
              <span class="value">产品名称：{{ item.productName }}</span>
            </div>
            <div class="info-row" style="margin-top: 5px">
              <span class="value">产品分类：{{ item.productType }}</span>
            </div>
            <div class="info-row clamp1" style="margin-top: 3px">
              <span class="value">备注：{{ item.productRemark }}</span>
            </div>
          </div>

          <div class="card-footer">
            <span v-if="item.demandStatus == 'release'" class="status-tag status-valid">待验样 / 验样中</span>
            <span v-if="item.demandStatus == 'wait_order'" class="status-tag status-blue">待发起</span>
            <!-- <span v-if="item.demandStatus == 'xxx'" class="status-tag status-bid">待竞价</span>
            <span v-if="item.demandStatus == 'xxx'" class="status-tag status-check">待验样</span> -->
            <span v-if="item.demandStatus == 'bidding'" class="status-tag status-bidding">待竞价 / 竞价中</span>
            <span v-if="item.demandStatus == 'repurchase_bidding'" class="status-tag status-blue">复购竞价</span>

            <div class="action-btns">
              <button v-if="item.demandStatus == 'draft'" class="btn btn-apply" @click="handleApply(item)">申请验样</button>
              <button class="btn btn-detail" @click="handleDetail(item)">查看详情</button>
              <button v-if="item.demandStatus == 'draft'" class="btn btn-detail" @click="handleBid(item)">提交竞价</button>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        class="result-pagination"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pageNum"
        :page-sizes="[6, 12, 18]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        background
      />
    </div>
  </div>
</template>

<script>
import TopBanner from "@/components/TopBanner.vue";
import SearchBar from "@/components/SearchBar.vue";
import { getMyProductType } from "@/api/demand";
import { getDemandList, getDictData } from "@/api";

export default {
  name: "SearchResult",
  components: {
    TopBanner,
    SearchBar,
  },
  data() {
    return {
      category: "",
      keyword: "",
      filterCategory: "all",
      productTypes: [],
      loading: false,
      resultList: [],
      // 分页
      pageNum: 1,
      pageSize: 6,
      total: 0,
      myProductTypeList: [],
    };
  },
  created() {
    this.loadSearchDataFromStorage();
    // this.fetchDict();
    this.fetchDemandList();
    this.getMyProductTypeFun();
  },
  methods: {
    getMyProductTypeFun() {
      getMyProductType().then((res) => {
        this.myProductTypeList = res.rows;
      });
    },
    // 获取数据字典
    fetchDict() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },
    // 调用产品需求列表接口
    async fetchDemandList() {
      this.resultList = [];
      this.loading = true;
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
        if (this.keyword && this.keyword.trim()) {
          params.productName = this.keyword.trim();
        }
        // 优先使用下拉筛选的分类，若为"全部分类"则使用搜索栏传入的分类
        const productType = this.filterCategory !== "all" ? this.filterCategory : this.category;
        if (productType) {
          params.productTypeId = productType;
        }
        const res = await getDemandList(params);
        if (res.code === 200 && res.rows) {
          this.resultList = res.rows.map((row) => ({
            ...row,
          }));
          this.total = res.total || 0;
        } else {
          this.resultList = [];
          this.total = 0;
        }
      } catch (error) {
        this.$message.error(error);
        this.resultList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    loadSearchDataFromStorage() {
      const stored = localStorage.getItem("supplierSearchData");
      if (stored) {
        try {
          const data = JSON.parse(stored);
          this.keyword = data.keyword || "";
          this.category = data.category || "";
        } catch (e) {
          this.keyword = "";
          this.category = "";
        }
      }
    },
    handleApply(item) {
      console.log("申请验样", item);
    },
    handleBid(item) {
      console.log("提交竞价", item);
    },
    handleDetail(item) {
      this.$router.push({
        path: `/demand-detail/${item.demandId}`,
      });
    },

    handleSearch() {
      if (!this.category) {
        this.$message.warning("请选择分类");
        return;
      }
      console.log("搜索", this.category, this.keyword);
      // 保存搜索数据到 localStorage，供其他页面跳转回来时读取
      localStorage.setItem(
        "supplierSearchData",
        JSON.stringify({
          category: this.category,
          keyword: this.keyword.trim(),
        })
      );
      // 保存最近搜索记录（与 SearchHome 共享同一个 localStorage key）
      if (this.keyword && this.keyword.trim()) {
        const trimmed = this.keyword.trim();
        let recentTags = [];
        const stored = localStorage.getItem("recentSearches");
        if (stored) {
          try {
            recentTags = JSON.parse(stored);
          } catch (e) {
            recentTags = [];
          }
        }
        recentTags = recentTags.filter((tag) => tag !== trimmed);
        recentTags.unshift(trimmed);
        if (recentTags.length > 6) {
          recentTags = recentTags.slice(0, 6);
        }
        localStorage.setItem("recentSearches", JSON.stringify(recentTags));
      }
      this.pageNum = 1;
      this.fetchDemandList();
    },
    handlePageChange(page) {
      this.pageNum = page;
      this.fetchDemandList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.fetchDemandList();
    },
  },
  watch: {
    // 切换分类下拉时重新查询
    filterCategory() {
      this.pageNum = 1;
      this.fetchDemandList();
    },
    // 监听路由变化：从其他页面跳转回来时，重新读取 localStorage 中的搜索数据
    $route(to) {
      if (to.path === "/search-result") {
        this.loadSearchDataFromStorage();
        this.pageNum = 1;
        this.fetchDemandList();
      }
    },
  },
};
</script>

<style scoped>
.search-result-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f0f4fa;
}

.search-scroll-area {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.header-bar {
  max-width: 1200px;
  margin: 20px auto 18px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-select {
  width: 118px;
  height: 38px;
}

.filter-select /deep/ .el-input__inner {
  background: transparent;
  border-radius: 8px;
  border-color: #adadad;
  font-size: 16px;
  height: 38px;
  line-height: 38px;
}

.result-list {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 60px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.result-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 18px 0 14px 0;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
}

.result-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ededed;
  padding-left: 14px;
  padding-right: 15px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 7px;
}

.avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-name {
  font-size: 16px;
  color: #333;
  font-weight: 400;
}

.contact-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  color: #666;
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
}

.company {
  font-size: 12px;
  color: #999999;
  font-weight: 400;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  line-height: normal;
  margin-top: 3px;
}

.card-body {
  flex: 1;
  margin-bottom: 40px;
  padding-left: 12px;
  padding-right: 12px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: normal;
}

.info-row.clamp1 .value {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #f0f0f0;
  padding-top: 14px;
  padding-left: 12px;
  padding-right: 18px;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
}

.status-valid {
  background: rgba(0, 166, 62, 0.1);
  color: #00a63e;
}

.status-bid {
  background: #ffecd5;
  color: #b66100;
}

.status-check {
  background: rgba(191, 191, 191, 0.2);
  color: #666666;
}

.status-bidding {
  background: rgba(235, 82, 0, 0.1);
  color: #ff0000;
}

.status-draft {
  background: rgba(153, 153, 153, 0.15);
  color: #999999;
}

.status-close {
  background: rgba(191, 191, 191, 0.2);
  color: #999999;
}

.status-blue {
  background: #e3edff;
  color: #1869ff;
}

.action-btns {
  display: flex;
  gap: 10px;
}
.action-btns .btn {
  width: 90px;
  height: 38px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
}

.btn-detail {
  color: #409eff;
  background: #fff;
  border: 1px solid #1869ff;
}

.btn-detail:hover,
.btn-detail:focus {
  background: #ecf5ff;
  border-color: #409eff;
  color: #409eff;
}

.btn-apply {
  background: #fff;
  color: #ff8801;
  border: 1px solid #ff8801;
}

.btn-apply:hover,
.btn-apply:focus {
  background: #fff7e6;
  border-color: #ff9318;
  color: #ff9318;
}

.search-btn {
  width: 150px;
  height: 52px;
  margin-left: 12px;
  background: linear-gradient(270deg, #ff9318 0%, #ff6b35 100%);
  border: none;
  border-radius: 9px;
  font-size: 19px;
}

.search-btn:hover,
.search-btn:focus {
  background-color: #e66d00;
  border-color: #e66d00;
}

@media (max-width: 992px) {
  .result-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .result-list {
    grid-template-columns: 1fr;
  }
}

.result-pagination {
  max-width: 1200px;
  margin: 0 auto 0 auto;
  text-align: right;
}
</style>
